import { render } from "./AIML.vue?vue&type=template&id=3fe66256&scoped=true"
import script from "./AIML.vue?vue&type=script&lang=js"
export * from "./AIML.vue?vue&type=script&lang=js"

import "./AIML.vue?vue&type=style&index=0&id=3fe66256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe66256"]])

export default __exports__